<div class="page-header" fxLayout="row" fxLayoutAlign="space-between center" fxLayout.xs="column" fxLayout.sm="column">
    <div class="page-info">

        <div *ngIf="btnAtras" class="back-btn">
            <button mat-icon-button color="primary" matTooltip="Atras" (click)="backPage()">
                <mat-icon>arrow_back</mat-icon>
            </button>
        </div>

        <div class="titles-box" fxLayout="column" fxLayoutAlign="center start">

            <div class="title">
                {{ titulo ? titulo : 'Titulo de pagina' }}
            </div>

        </div>

    </div>

    <!-- contenedor de botones -->
    <app-generic-form-btn [btns]="btnAccionList" (pressBtn)="action($event)"></app-generic-form-btn>

</div>
